import { ImageViewerStyled } from './styles/ImageViewerStyled'
import {
  type IImageCropperProps,
  ImageCropper,
} from '../ImageCropper/ImageCropper'

export interface ImageViewerProps
  extends Pick<IImageCropperProps, 'image' | 'minZoom' | 'maxZoom'> {
  alt?: string
}

export const ImageViewer = ({
  image,
  minZoom = 1,
  maxZoom = 5,
  alt,
}: ImageViewerProps) => {
  return (
    <ImageViewerStyled>
      <ImageCropper
        alt={alt}
        image={image}
        minZoom={minZoom}
        maxZoom={maxZoom}
        viewOnly={true}
      />
    </ImageViewerStyled>
  )
}
